import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { base_url, postHeader } from '../../Helper/request';
import axios from 'axios';
import { toast } from 'react-toastify';

const Forget = () => {
    const [email,setEmail]=useState("");
    const [loader,setloader]=useState(false);

    const onSubmit = (e) => {
        e.preventDefault();
        
        const iData = {
          email
        }
        setloader(true);
        const options = {
          method: "POST",
          headers: postHeader
        };
    
        axios.post(base_url + "/user/forget_password", iData, options).then((res) => {
          if (res?.data?.status === 1) {
            toast.success(res?.data?.message);
            setloader(false);
          } else {
            toast.error(res?.data?.message);
            setloader(false);
          }
        });
      }

  return (
    <div className='mt-0'>
        <h3 className='subtitle mb-3'>
        Forgot Your Password?
        </h3>
    <Form onSubmit={onSubmit} className='mt-0'>
         <Form.Control onChange={(e) => setEmail(e.target.value)}  name="email" type="email" value={email} placeholder="Enter Your Email" required={true}/>
         <Button className='theme_btn mt-3 login_btn' variant="primary1" type="submit" onSubmit={()=>onSubmit()}>{loader ? "Sending..." : "Submit"}</Button>
    </Form>
    </div>

  )
}

export default Forget